// Strip dash uit IDs voor visuele weergave (RP-00001 → RP00001).
// API-calls en URL-paths gebruiken nog steeds de originele ID met dash.
export const fmtId = (id) => (id ? id.replace('-', '') : id);

// Doel-labels komen uit util/doelen — daar staat de enige lijst. Hier stond een
// tweede exemplaar dat langzaam uit de pas was gaan lopen: "Grasland- en
// gewasberegening" tegenover "Grasland- én gewasberegening" in de backend, en
// "Vollegrondstuinbouw" tegenover "Vollegronds tuinbouw" in doelen.js zelf.
// De naam doelLabel blijft, zodat de historie-weergave niets hoeft te weten.
export { labelVoorDoel as doelLabel } from './doelen';

// Label voor het type gebruiksrecht-kenmerk.
const KENMERK_TYPE_LABELS = {
  verzoeknummer: 'Verzoeknummer',
  zaaknummer: 'Zaaknummer',
  besluitnummer: 'Besluitnummer',
};

export const kenmerkTypeLabel = (type) => KENMERK_TYPE_LABELS[type] || 'Kenmerk';

// Datum "2026-02-01" → "1 februari 2026". Leeg/onbekend → '—'.
const NL_MAANDEN = ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
  'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

export const fmtDatumNL = (iso) => {
  if (!iso) return '—';
  const d = String(iso).slice(0, 10).split('-');
  if (d.length !== 3) return iso;
  const dag = parseInt(d[2], 10);
  const maand = NL_MAANDEN[parseInt(d[1], 10) - 1] || d[1];
  return `${dag} ${maand} ${d[0]}`;
};

/* Een foutmelding van de server, leesbaar gemaakt.

   Let op de array: bij een 422 stuurt FastAPI geen zin maar een lijst met per
   veld een melding. Die lijst rauw in JSX zetten geeft React-fout #31 en dus
   een grijs scherm — precies op het moment dat er al iets misging. */
export const leesbareFout = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => {
      const veld = Array.isArray(d.loc) ? d.loc.filter((x) => x !== 'body').join(' → ') : '';
      return veld ? `${veld}: ${d.msg}` : d.msg;
    }).filter(Boolean).join('; ');
  }
  return e?.message || 'Onbekende fout';
};

// Geldigheidsperiode van een gebruiksrecht: inwerkingtreding – uitwerkingtreding.
// Uitwerkingtreding is INCLUSIEF ("t/m"); leeg betekent lopend ("heden").
export const fmtPeriode = (inwerking, uitwerking) =>
  `${fmtDatumNL(inwerking)} t/m ${uitwerking ? fmtDatumNL(uitwerking) : 'heden'}`;


/* De diepte van een put zoals hij in een tabel staat, uit de velden die de
   backend afleidt (boorstatus.py): "max. 60" bij een put die nog geboord moet
   worden, "ca. 42" bij een opgegeven diepte, "38,5" bij een gemeten, en een
   streepje als er niets is. Zonder eenheid; die staat in de kolomkop. */
export function dieptetekst(p) {
  if (p.diepte == null) return '—';
  const n = String(p.diepte).replace('.', ',').replace(/,0+$/, '');
  if (p.diepte_bron === 'max') return `max. ${n}`;
  if (p.diepte_bron === 'opgegeven') return `ca. ${n}`;
  return n;
}
